var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-fill)",
  fillRule: "evenodd",
  d: "M24 5a19 19 0 1 1 0 38 19 19 0 0 1 0-38",
  clipRule: "evenodd",
  "data-filled": "true"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-fill)",
  fillRule: "evenodd",
  d: "M24 4a20 20 0 1 0-.01 39.99A20 20 0 0 0 24 4m0 37.4c-9.59 0-17.4-7.81-17.4-17.4S14.41 6.6 24 6.6 41.4 14.41 41.4 24 33.59 41.4 24 41.4",
  clipRule: "evenodd",
  "data-filled": "false"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-accent-fill, var(--thc-icon-accent-fill-default, white))",
  fillRule: "evenodd",
  d: "M24 34.4a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-6.01c.72 0 1.3-.58 1.3-1.3V13.71a1.3 1.3 0 1 0-2.6 0v13.38c0 .72.58 1.3 1.3 1.3",
  clipRule: "evenodd"
})));
export { SvgError as ReactComponent };
export default new URL("/home/runner/work/motorway-seller-webapp/motorway-seller-webapp/node_modules/@motorway/mw-highway-code/src/assets/svgs/error.svg", import.meta.url).toString();